import { ReactComponent as Logo } from "../../static/wsp_logo_black.svg";

const AppFooter = () => {
    const date = new Date();

    return (
      <footer className="app-footer__container">
        <div className="cds--grid">
          <div className="cds--row">
            <div className="cds--col-sm-4 cds--col-md-2 cds--col-lg-2">
              <Logo className="wsp_logo" />
            </div>
            <div className="cds--col-sm-4 cds--col-md-6 cds--col-lg-14">{`© ${date.getFullYear()} WSP Canada Inc.`}</div>
          </div>
        </div>
      </footer>
    );
  };

  export default AppFooter;
